import { SET_EMPLOYEES_DISABLE_FILTER } from "../actions/actionTypes";

export const showDisabledEmployees = (state = false, action) => {
	switch (action.type) {
		case SET_EMPLOYEES_DISABLE_FILTER:
			return action.payload;

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/filter.js